import { Component } from '@angular/core';

@Component({
	selector: 'seira-para-voce',
	templateUrl: './para-voce.component.html',
	styleUrls: ['./para-voce.component.scss'],
})
export class ParaVoceComponent {}
